import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { GABRIELA_SUBTITLE, CHANIRA_SUBTITLE } from '../config';
import { QueensPhoto } from './QueensPhoto';
import { Reveal } from './Reveal';

// One shared photo of both Queens: Gabriela on the left (blonde), Chanira on the
// right (dark curly hair). No individual portrait slots.
const PROFILES = [{
  name: 'GABRIELA',
  // Optional. Renders nothing while empty — never generate a placeholder credential.
  subtitle: GABRIELA_SUBTITLE,
  bio: 'queens.gabriela.bio'
}, {
  name: 'CHANIRA',
  subtitle: CHANIRA_SUBTITLE,
  bio: 'queens.chanira.bio'
}];
export function MeetTheQueens() {
  const {
    t
  } = useLanguage();
  return <section id="queens" className="w-full bg-white" data-id="element-325" data-mp="1amiod5ke0s47">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 md:py-24" data-id="element-326" data-mp="37fvau5wo0a2e">
        <Reveal className="max-w-2xl" data-id="element-327" data-mp="37hyalhnmdhkb">
          <p className="font-display text-[11px] font-bold uppercase tracking-[0.24em] text-camelink" data-id="element-328" data-mp="3ceews6b9dlur">
            {t('queens.eyebrow')}
          </p>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-329" data-mp="3alat18k8l0y" />
          <h2 className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl" data-id="element-330" data-mp="3umwnqasoqkkl">
            {t('queens.title')}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-body sm:text-lg" data-id="element-331" data-mp="3lo2la3soazz4">
            {t('queens.support')}
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-center lg:gap-14" data-id="element-332" data-mp="m7czxras9ucx">
          <Reveal data-id="element-333" data-mp="d7hl9ci0rh85">
            <QueensPhoto data-id="element-334" data-mp="d6ycome9e56s" />
          </Reveal>

          <div className="space-y-10" data-id="element-335" data-mp="d5mxzrj9zd0w">
            {PROFILES.map((profile, index) => <Reveal key={profile.name} delay={index * 0.1} data-id="element-336" data-mp="87v7n1ya3yyt" data-mpi={index}>
                <article data-id="element-337" data-mp="2xy8b5tzqnpik">
                  <h3 className="font-display text-2xl font-extrabold uppercase tracking-[0.14em] text-ink" data-id="element-338" data-mp="2xyi2pm0fm4qd">
                    {profile.name}
                  </h3>
                  {profile.subtitle ? <p className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-camelink" data-id="element-339" data-mp="2ugauif5eks5x">
                      {profile.subtitle}
                    </p> : null}
                  <div aria-hidden="true" className="mt-4 h-px w-14 bg-camel" data-id="element-340" data-mp="2lel2p87lzr7m" />
                  <p className="mt-4 text-base leading-relaxed text-body" data-id="element-341" data-mp="2qd4ptbxxv91k">{t(profile.bio)}</p>
                </article>
              </Reveal>)}
          </div>
        </div>

        <Reveal className="mt-14" delay={0.1} data-id="element-342" data-mp="2ggjmqw5hc80d">
          <blockquote className="mx-auto max-w-3xl text-center font-display text-xl font-semibold leading-snug text-ink sm:text-2xl" data-id="element-343" data-mp="2ghb6n9ppshat">
            {t('queens.quote')}
            <footer className="mt-4 text-[11px] font-bold uppercase tracking-[0.24em] text-camelink" data-id="element-344" data-mp="26r8etcubx9e2">
              Gabriela + Chanira
            </footer>
          </blockquote>
        </Reveal>
      </div>
    </section>;
}